module.exports = __webpack_public_path__ + "img/slide3.f8f56261.svg";